const colorConfigs = {
  sidebar: {
    bg: "#fff",
    color: "#1e1e44",
    hoverBg: "#f5f5f5",
    activeBg: "#f5f5f5",
  },
  topbar: {
    bg: "#fff",
    color: "#1e1e44",
  },
  mainBg: "#fff",
};

export default colorConfigs;
